import { atom } from 'jotai'

export const conversationUIStateAtom = atom<{ hideUI: boolean }>({
  hideUI: false
})